import { IconButton, Spinner, Tooltip, keyframes } from "@chakra-ui/react";
import { EmrEar } from "@medstonetech/slate-icons";
import { useHHERAllyContext } from "contexts";
import * as React from "react";
import { useTypewriter } from "../../hooks/useTypewriter";

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;

const SUMMARY_LOADING_PHRASES = [
  "Analyzing chart data...",
  "Reviewing patient history...",
  "Generating summary...",
];

function HHERAllyToggle() {
  const {
    isRecording,
    startListening,
    stopListening,
    openPanel,
    isSummaryLoading,
  } = useHHERAllyContext();

  const loadingText = useTypewriter(SUMMARY_LOADING_PHRASES, isSummaryLoading);

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    if (isRecording) {
      await stopListening();
    } else {
      await startListening();
    }

    openPanel();
  };

  const baseAriaLabel = isRecording ? "Stop listening" : "Start listening";

  return (
    <Tooltip
      label={loadingText || "Generating Ally summary..."}
      isOpen={isSummaryLoading}
      hasArrow
      placement="top"
    >
      <IconButton
        aria-label={baseAriaLabel}
        icon={
          isSummaryLoading ? (
            <Spinner size="xs" color="white" />
          ) : (
            <EmrEar style={{ width: "9px", height: "13px" }} />
          )
        }
        onClick={handleClick}
        width="30px"
        height="30px"
        minWidth="30px"
        padding="0"
        borderRadius="full"
        border="1px solid"
        borderColor="white"
        backgroundColor={isRecording ? "#34C759" : "#FF3B30"}
        color="white"
        _hover={{
          backgroundColor: isRecording ? "#2DA84A" : "#D9322A",
        }}
        animation={
          isRecording ? `${pulse} 1.5s infinite ease-in-out` : undefined
        }
      />
    </Tooltip>
  );
}

export { HHERAllyToggle, SUMMARY_LOADING_PHRASES };
